class ComboQuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
  
      this.input.addEventListener('change', this.onInputChange.bind(this));
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    quantityUpdateUnsubscriber = undefined;
  
    connectedCallback() {
      this.validateQtyRules();
      this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }
  
    disconnectedCallback() {
      if (this.quantityUpdateUnsubscriber) {
        this.quantityUpdateUnsubscriber();
      }
    }
  
    onInputChange(event) {
      this.validateQtyRules();
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const cardWrapper = this.closest(".card-wrapper");
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      const moq = cardWrapper.getAttribute('data-moq');
      if(previousValue == moq && event.target.name === "minus"){
        event.preventDefault();
        if(cardWrapper){
          cardWrapper.removeAttribute('selected');
        }
      }
      if (previousValue !== this.input.value){
        this.input.dispatchEvent(this.changeEvent);
        cardWrapper.setAttribute('data-product-quantity', this.input.value)
        
      } 
    }
  
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        if(buttonPlus){
          buttonPlus.classList.toggle('disabled', value >= max);
        }
      }
    }
  }
  
  customElements.define('combo-quantity-input', ComboQuantityInput);

  function addBundleToCart(event) {
    var itemsArray = [];
    var sectionDiv = document.getElementById('multi-select');
    var atcButton = event.target.closest('.view-button');
    var selectedCards = document.getElementById('multi-select').querySelectorAll(".card-wrapper[selected='true']");
    var quantityReqd = 0;
    var quantityReqdString = sectionDiv.getAttribute('data-quantity-reqd');
    var addonProductId = sectionDiv.getAttribute('data-addon-product');
    if(quantityReqdString){
      quantityReqd = parseInt(quantityReqdString);
    }
    var totalQuantity = 0;
    if (selectedCards.length > 0) {
      for (var s = 0; s < selectedCards.length; s++) {
        var id = selectedCards[s].getAttribute('data-product-id');
        var quantity = selectedCards[s].querySelector('.quantity__input').value;
        var intQuant = parseInt(quantity);
        var totalQuantity = totalQuantity + intQuant;
        itemsArray.push({
          id: parseInt(id),
          quantity: intQuant,
          properties: {
            _multi_select: true,
          },
        });
      }
    }

    if (itemsArray.length > 0 && totalQuantity >= quantityReqdString) {
      if(addonProductId){
        itemsArray.push({
          id: parseInt(addonProductId),
          quantity: 1,
          properties: {
            _multi_select: true,
          },
        });
      }
      atcButton.innerText = 'Adding to Cart...';
      var cartNotification = document.querySelector('cart-notification');
      let formData = {
        items: itemsArray,
        sections: cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          atcButton.innerText = 'Added to Cart';
          checkCart();
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'multi-select' });

          setTimeout(() => {
            const selectAll = document.getElementById('select-all');
            if(selectAll){
              selectAll.innerText = selectAll.getAttribute("data-select-all-text");
              selectAll.setAttribute("data-all-selected","false");
            }
            atcButton.innerText = 'Add Deal to Cart';
          }, 2000);
          setTimeout(() => {
            selectedCards = document.querySelectorAll(".card-wrapper[selected='true']");
            for (var s = 0; s < selectedCards.length; s++) {
              let moq = selectedCards[s].getAttribute('data-moq');
              selectedCards[s].removeAttribute('selected');
              selectedCards[s].querySelector('.quantity__input').value = moq;
              selectedCards[s].setAttribute('data-product-quantity', moq);
            }
            const atcFooter = document.getElementById('atc-footer');
            atcFooter.classList.add('hidden');
          }, 2050);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }
  function itemRemove(event){
    const sectionId = document.getElementById('multi-select').getAttribute('data-section-id');
    const selectionCard = event.target.closest('.card-wrapper');
    const ogCarouselHandle = selectionCard.getAttribute('data-carousel');
    const varId = selectionCard.getAttribute('data-product-id');
    const moq = selectionCard.getAttribute('data-moq');
    const ogCarousel = document.getElementById(sectionId + '-' + ogCarouselHandle);
    if (ogCarousel) {
      const ogCards = ogCarousel.querySelectorAll(
        '.card-wrapper[data-product-id="' + varId + '"]'
      );
      for (var c = 0; c < ogCards.length; c++) {
        ogCards[c].removeAttribute('selected');
        ogCards[c].querySelector('.quantity__input').value = moq;
        ogCards[c].setAttribute('data-product-quantity', moq);
      }
      selectionChangeQuantity();
    }
  }


  function selectionChangeQuantity() {
    var allSelectedCards = document.getElementById('multi-select').querySelectorAll(".card-wrapper[selected='true']");
    var sectionDiv = document.getElementById('multi-select');
    var atcFooter = document.getElementById('atc-footer');
    var atcFooterButton = document.getElementById('multi-select-atc');
    var currentQuantityDiv = document.getElementById('multi-select-quantity');
    var quantityReqd = 0;
    var quantityReqdString = sectionDiv.getAttribute('data-quantity-reqd');
    if(quantityReqdString){
      quantityReqd = parseInt(quantityReqdString);
    }
    var atcText = sectionDiv.getAttribute('data-text');
    var disabledAtcText = sectionDiv.getAttribute('data-disabled-text');
    if (allSelectedCards.length > 0) {
      var totalQuantity = 0;
      for (var s = 0; s < allSelectedCards.length; s++) {
        totalQuantity = totalQuantity + parseInt(allSelectedCards[s].getAttribute('data-product-quantity'));
      }
      currentQuantityDiv.innerText = totalQuantity;
      if(totalQuantity >= quantityReqd){
        atcFooterButton.innerText = atcText;
        atcFooterButton.removeAttribute("disabled");
      }
      else{
        atcFooterButton.innerText = disabledAtcText;
        atcFooterButton.setAttribute("disabled", "");
      }
    
      atcFooter.classList.remove('hidden');
    } else {
      currentQuantityDiv.innerText = 0;

      atcFooterButton.innerText = disabledAtcText;
      atcFooterButton.setAttribute("disabled", "");
      atcFooter.classList.add('hidden');
    }
  }